import { axiosClient } from '../axiosClient';

// Áreas disponíveis para vagas — espelham o backend (config/careers.js).
export const JOB_AREAS = [
  'Engenharia',
  'Produto & Design',
  'Comercial',
  'Suporte',
  'Campo & Agro',
] as const;

export type JobArea = (typeof JOB_AREAS)[number];

export type JobStatus = 'aberta' | 'fechada';

export interface Job {
  id: number;
  slug: string;
  titulo: string;
  area: string;
  tipoContrato: string;
  local: string;
  resumo: string;
  descricao: string;
  responsabilidades: string[];
  requisitos: string[];
  processo: string;
  status: JobStatus;
  ordem: number;
  candidaturasCount: number;
  createdAt: string;
}

export interface JobInput {
  titulo: string;
  area: string;
  tipoContrato: string;
  local: string;
  resumo: string;
  descricao: string;
  responsabilidades: string[];
  requisitos: string[];
  processo: string;
  status: JobStatus;
  ordem: number;
  slug?: string;
}

export type ApplicationType = 'banco' | 'vaga';
export type ApplicationStatus = 'novo' | 'em_analise' | 'contatado' | 'arquivado';

export interface JobApplication {
  id: number;
  tipo: ApplicationType;
  vagaId: number | null;
  vagaTitulo: string | null;
  nome: string;
  whatsapp: string;
  email: string;
  area: string;
  linkedin: string | null;
  mensagem: string | null;
  status: ApplicationStatus;
  createdAt: string;
}

export interface ApplicationFilters {
  vagaId?: number;
  tipo?: ApplicationType;
  status?: ApplicationStatus;
}

export const careersApi = {
  listJobs: async (): Promise<Job[]> => {
    const res = await axiosClient.get<{ jobs: Job[] }>('/manager/careers/jobs');
    return res.data.jobs ?? [];
  },

  createJob: async (data: JobInput): Promise<Job> => {
    const res = await axiosClient.post<{ job: Job }>('/manager/careers/jobs', data);
    return res.data.job;
  },

  updateJob: async (id: number, data: JobInput): Promise<Job> => {
    const res = await axiosClient.put<{ job: Job }>(`/manager/careers/jobs/${id}`, data);
    return res.data.job;
  },

  deleteJob: async (id: number): Promise<void> => {
    await axiosClient.delete(`/manager/careers/jobs/${id}`);
  },

  listApplications: async (filters: ApplicationFilters): Promise<JobApplication[]> => {
    const res = await axiosClient.get<{ applications: JobApplication[] }>(
      '/manager/careers/applications',
      {
        params: {
          vagaId: filters.vagaId,
          tipo: filters.tipo,
          status: filters.status,
        },
      }
    );
    return res.data.applications ?? [];
  },

  getApplicationCvUrl: async (id: number): Promise<string> => {
    const res = await axiosClient.get<{ url: string }>(`/manager/careers/applications/${id}/cv`);
    return res.data.url;
  },

  updateApplicationStatus: async (id: number, status: ApplicationStatus): Promise<void> => {
    await axiosClient.patch(`/manager/careers/applications/${id}`, { status });
  },
};
